<kh-dialog-header mat-dialog-title>{{ siteAlias }} Upload Error </kh-dialog-header>

<div
    mat-dialog-content
    class="kh-dialog-content-no-scroll body-medium"
>
    @if (data.siteTemplateError) {
        <span
            >We found the following error(s) and were unable to upload your {{ sitesAliasLowerCase }}. Please correct
            the error(s) and reupload the file to proceed.</span
        >
    } @else {
        <span>
            We found the following error(s) in your Excel spreadsheet and were unable to upload your
            {{ sitesAliasLowerCase }}. Please correct the error(s) and reupload the file to proceed.
        </span>
    }
    <div class="kh-notification">
        @if (data.missingSiteNumbers) {
            <kh-inline-notification-error>
                <span class="kh-bold-text">Missing {{ siteAliasLowerCase }} numbers. </span>
                <span class="kh-flex-grow-shrink">
                    &nbsp; Ensure each {{ siteAliasLowerCase }} has a corresponding unique
                    {{ siteAliasLowerCase }} number.</span
                >
            </kh-inline-notification-error>
        }
        @if (data.duplicateSiteNumbers.length > 0) {
            <kh-inline-notification-error>
                <span class="kh-bold-text">Duplicate {{ siteAliasLowerCase }} numbers. &nbsp;</span
                ><span class="kh-flex-grow-shrink">
                    Remove or correct the following duplicate {{ siteAliasLowerCase }} numbers:
                    {{ data.duplicateSiteNumbers.join(', ') }}</span
                >
            </kh-inline-notification-error>
        }
        @if (data.missingSiteNames) {
            <kh-inline-notification-error>
                <span class="kh-bold-text">Missing {{ siteAliasLowerCase }} names.</span>
                <span class="kh-flex-grow-shrink">
                    &nbsp; Ensure each {{ siteAliasLowerCase }} has a corresponding {{ siteAliasLowerCase }} name.</span
                >
            </kh-inline-notification-error>
        }
        @if (data.missingAddress) {
            <kh-inline-notification-error>
                <span class="kh-bold-text">Missing address details.</span>
                <span class="kh-flex-grow-shrink">
                    &nbsp; Ensure each {{ siteAliasLowerCase }} has a complete address, including the street number and
                    name, city, state and zip code.</span
                >
            </kh-inline-notification-error>
        }
        @if (data.invalidAddresses.length > 0) {
            <kh-inline-notification-error>
                <div>
                    <span class="kh-bold-text">Invalid addresses.</span>
                    <span class="kh-flex-grow-shrink"> &nbsp; Correct the following invalid addresses:</span>
                </div>
                <div>
                    <ul>
                        @for (address of data.invalidAddresses; track address) {
                            <li>
                                {{ address.addressName }} {{ address.city }}, {{ address.state }} {{ address.zipCode }}
                            </li>
                        }
                    </ul>
                </div>
            </kh-inline-notification-error>
        }
        @if (data.siteTemplateError) {
            <kh-inline-notification-error>
                <span class="kh-bold-text">{{ siteAlias }} Template not found.</span>
                <span class="kh-flex-grow-shrink">
                    &nbsp; The {{ siteAliasLowerCase }} template you selected is no longer available. Please select a
                    different {{ siteAliasLowerCase }} template.</span
                >
            </kh-inline-notification-error>
        }
    </div>
    <kh-app-text-button
        (clicked)="openFeedbackForm()"
        icon="help"
    >
        Get help
    </kh-app-text-button>
</div>
<div
    mat-dialog-actions
    class="khts-mat-dialog-actions"
    align="end"
>
    <kh-app-flat-button mat-dialog-close>Close</kh-app-flat-button>
</div>
